export const formatTime = milliseconds => {
    const minutes = Number.parseInt((milliseconds / 60) % 60, 10);
    const seconds = Number.parseInt(milliseconds % 60, 10);

    const addLeadZero = num => num.toString().padStart(2, '0');

    return `${addLeadZero(minutes)}:${addLeadZero(seconds)}`;
};
